<template>
  <div>
    <v-container style="height: 100%;" pt-7 px-6 ma-0 fluid>
      <v-row no-gutters>
        <v-col>
          <v-card style="border-radius: 20px;" class="white">
            <v-card-title class="header-border pa-0 ma-0">
              <v-row class="ml-0" no-gutters align="start" justify="start" style="width: 0px;">
                <v-col>
                  <tabs-cadu
                    v-if="loading"
                    :tabs="tabs"
                    :currentTab="currentTab" 
                    :borderColor="greenColor"
                    :textColor="greyColor"
                    :textColorActive="greenColor"
                    @onClick="handleClick"
                    ref="tab"
                  />
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text style="min-height: 700px;margin-top: 30px;" class="vueBox">
              <GenericComponent @cancelar="cancelarButton" ref="generic" :tabIndex="tabIndex" />
            </v-card-text>
            <v-card-actions class="mx-4 mt-4 mb-4" style="border-top: 1px solid #9e9e9e80;">
              <v-col cols="12" class="footer-dados px-8 pb-0" v-if="!$vuetify.breakpoint.xs"
              style="min-height: 60px;">
                <v-row v-if="opcaoEditar">
                  <v-col cols="auto" v-if="showButtonCancelar">
                    <button-cadu @click="chooseTab" outline :backColor="$vuetify.theme.themes.light.primary1">
                      CANCELAR
                    </button-cadu>
                  </v-col>

                  <v-row align="center" justify="end">
                    <v-col cols="auto">
                      <button-cadu :backColor="$vuetify.theme.themes.light.primary2" @click="showCancelarVersao = true">
                        VOLTAR
                      </button-cadu>
                    </v-col>
                    <v-col cols="auto" v-if="canSave && opcaoEditar">
                      <button-cadu @click="verifySalvarVersao" :backColor="$vuetify.theme.themes.light.primary1">
                        SALVAR VERSÃO
                      </button-cadu>
                    </v-col>
                  </v-row>
                </v-row>
                <v-row v-else justify="end">
                  <v-col cols="auto">
                    <button-cadu :backColor="$vuetify.theme.themes.light.primary2" @click="goToHomeEditar()">
                      VOLTAR
                    </button-cadu>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-else>
                <v-row v-if="opcaoEditar">
                  <v-col class="mt-4" cols="12" v-if="canSave">
                    <button-cadu
                      text="SALVAR VERSÃO"
                      @click="verifySalvarVersao"
                      :backColor="$vuetify.theme.themes.light.primary1"
                      block
                    />
                  </v-col>
                  <v-col cols="12">
                    <button-cadu
                      text="VOLTAR"
                      @click="showCancelarVersao = true"
                      :backColor="$vuetify.theme.themes.light.primary2"
                      block
                    />
                  </v-col>
                  <v-col cols="12" v-if="showButtonCancelar">
                    <button-cadu text="CANCELAR" @click="dados()" :outline="true" block />
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12">
                    <button-cadu
                      text="VOLTAR"
                      @click="goToHomeEditar()"
                      :backColor="$vuetify.theme.themes.light.primary2"
                      block
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <SucessoModal
      genericMessage="Atualização cancelada com sucesso!"
      :showSucess="showSucess"
      @close="goToHomeEditar"
    />

    <SucessoModal
      genericMessage="Documento anexado com sucesso!"
      :showSucess="showSuccessAnexo"
      @close="closeSucessoAnexo"
    />

    <SucessoModal
      :genericMessage="this.messageSucessoModal"
      :showSucess="showSuccessAtualizacao"
      @close="closeModalAtualizacao"
    />

    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao()" />

    <error-modal v-model="showError" :errObj="errObj" />

    <versao-modal @salvarVersao="mostrarModalDeSucesso" v-model="showCancelarVersao" :tipo="false" />

    <versao-modal @salvarVersao="salvarVersao" v-model="showModalVersao" tipo />

    <overlay-loading v-model="loadingCard" />

    <error-modal v-model="showErrorAlterado" :errObj="errObjAlterado">
      <div slot="footer-buttons">
        <v-row justify="end" no-gutters>
          <v-col cols="auto" class="pl-4">
            <button-cadu @click="showErrorAlterado = false">
              OK
            </button-cadu>
          </v-col>
        </v-row>
      </div>
    </error-modal>

    <modal-anexo
      :value="showModalAnexo"
      :aba="abaAnexo"
      @cancel="fecharModalAnexo"
      @create-another="createAnother()"
      @reload-grid="closeAnexo"
    />

    <ModalPendenciaGeral
      :value="showPendencia"
      @close="fecharPendencia"
      @anexarUpload="anexarUpload"
      @semAnexar="salvarVersao(true)"
      :titulo="tituloPendencia"
      :texto="textoPendencia"
    />
  </div>
</template>

<script>
import GenericComponent from './GenericComponent'
import VersaoModal from './VersaoModal'
import Unimed from '@/services/Unimed'
import Usuario from '@/services/Usuario'
import jwtDecode from 'jwt-decode'
import { EventBus } from '@/services/EventBus/EventBus'
import ModalPendenciaGeral from '../../Shared/ModalPendencia/ModalPendenciaGeral'

export default {
  components: {
    GenericComponent,
    VersaoModal,
    ModalPendenciaGeral
  },
  props: {
    unimedId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      tabs: [
        {
          title: 'DADOS CADASTRAIS',
          value: 'dados',
          disabled: false
        },
        {
          title: 'ÁREAS',
          value: 'areas',
          disabled: false
        },
        {
          title: 'PERFIL',
          value: 'perfil',
          disabled: false
        },
        {
          title: 'MANDATOS',
          value: 'mandatos',
          disabled: false
        },
        {
          title: 'ÁREA DE AÇÃO',
          value: 'areaAcao',
          disabled: false
        },
        {
          title: 'ANS',
          value: 'ans',
          disabled: false
        },
        {
          title: 'CERTIFICAÇÕES',
          value: 'certificacoes',
          disabled: false
        },
        {
          title: 'ANEXOS',
          value: 'anexos',
          disabled: false
        },
        {
          title: 'HISTÓRICO',
          value: 'historico',
          disabled: false
        }
      ],
      currentTab: 'dados',
      tabIndex: 0,
      greenColor: this.$vuetify.theme.themes.light.primary1,
      greyColor: '#9E9E9E',
      loading: false,
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      showSucess: false,
      showModalVersao: false,
      showCancelarVersao: false,
      showError: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      role: '',
      tokenBearer: '',
      showModalCancelar: false,
      showButtonCancelar: true,
      codigoUnimedVisualizada: this.unimedId,
      usuario: {},
      codigoMinhaUnimed: null,
      showModalAnexo: false,
      abaAnexo: '',
      showSuccessAnexo: false,
      showSuccessAtualizacao: false,
      messageAnexo: 'Documento anexado com sucesso!',
      type: 'add',
      anotherModal: false,

      // Modal Anexo Verifica Pendencia
      showPendencia: false,
      loadingCard: false,
      salvandoVersao: false,
      tituloPendencia: '',
      textoPendencia: '',
      showErrorAlterado: false,
      errObjAlterado: {
        status: '',
        error: ''
      },
      gerouPendencia: false
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
    this.canViewAnexos()
  },
  mounted() {
    EventBus.$on('showAnexo', (value) => {
      this.abaAnexo = value
      this.showModalAnexo = true
    })
    EventBus.$on('disabledMandatos', () => {
      this.showMandatos(true)
    })
    EventBus.$on('activeMandatos', () => {
      this.showMandatos(false)
    })
    EventBus.$on('cancelarDados', () => {
      this.$refs.generic.$refs.dados.validarDados()
    })

    this.$nextTick(() => {
      this.loading = true
    });

    EventBus.$on('verificaMudanca', () => {
      this.verificaMudanca()
    });    

    this.$nextTick(() => {
      this.loading = true
    });

    EventBus.$on('changeAbaMinhaUnimed', (data) => {
      if (data.tab !== null) {
        this.currentTab = data.tab;
        this.tabIndex = data.tabIndex;
        this.handleClick(data.tab, data);
      }
    });
  },
  computed: {
    canSave() {
      return this.role === 'admin_brasil' || this.role === 'dirigente' || this.role === 'admin'
    },
    messageSucessoModal() {
      if (this.role === 'admin_brasil' || !this.gerouPendencia) return 'Atualizado com sucesso!'
      return 'A sua atualização será analisada pela Unimed do Brasil!'
    }
  },
  watch: {
    tabIndex() {
      this.showButtonCancelar = this.tabIndex === 0 || this.tabIndex === 2
    }
  },
  methods: {
    fecharModalAnexo() {
      this.salvandoVersao = false
      this.showModalAnexo = false
    },
    fecharPendencia() {
      this.showPendencia = false
      this.salvandoVersao = false
    },
    async anexarUpload() {
      this.showPendencia = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
      this.showModalAnexo = true
    },
    async verifySalvarVersao() {
      if (!this.opcaoEditar) return
      if (this.currentTab === 'certificacoes') {
        const res = await this.$refs.generic.$refs.certificacoes.getResponseRight(true)
        if (!res) return
      }
      if (
        (this.currentTab === 'dados' && (await this.$refs.generic.$refs.dados.validarDados())) ||
        this.currentTab !== 'dados'
      ) {
        this.verificaMudanca()
      } else {
        this.showModalVersao = false
        this.loadingCard = false
      }
    },
    async verificaMudanca() {
      this.loadingCard = true

      const unimed = new Unimed(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)

      await unimed
        .getVerificaMudanca()
        .then((res) => {
          if (res.data.nadaAlterado) {
            this.showErrorAlterado = true
            this.errObjAlterado.status = '400'
            this.errObjAlterado.error = 'Não existem modificações salvas!'
            return
          }

          this.$nextTick()
          document.documentElement.style.overflow = 'hidden'
          this.showModalVersao = true
        })
        .catch((err) => {
          this.showError = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
        .finally(() => (this.loadingCard = false))
    },
    showMandatos(bool) {
      this.tabs[3].disabled = bool
    },
    closeAnexo() {
      this.showModalAnexo = false
      this.anotherModal = false
      this.showSuccessAnexo = true
    },
    closeSucessoAnexo() {
      this.showSuccessAnexo = false
      if (this.anotherModal) {
        this.showModalAnexo = true
      } else if (this.salvandoVersao) {
        this.salvarVersao(true)
      }
    },
    createAnother() {
      this.showModalAnexo = false
      this.anotherModal = true
      this.showSuccessAnexo = true
    },
    chooseTab() {
      try {
        this[this.currentTab]()
      } catch (err) {}
    },
    cancelarButton(value) {
      this.showButtonCancelar = value
    },
    async handleClick(newTab, options = null) {
      if (this.currentTab === 'certificacoes' && this.opcaoEditar && this.$refs.generic.$refs.certificacoes !== undefined) {
        const res = await this.$refs.generic.$refs.certificacoes.getResponseRight(true)
        if (!res) return
      }

      if ((this.currentTab === 'dados' && (await this.$refs.generic.$refs.dados.validarDados())) ||
        (this.currentTab !== 'dados')) {
        this.currentTab = newTab;
        this.tabIndex = this.tabs.findIndex((el) => el.value === this.currentTab)

        if (this.tabs[3].title !== 'MANDATOS' && this.tabIndex > 2) this.tabIndex++
        
        this.$emit('change-tab', { tabIndex: this.tabIndex, options: options });
      }
    },
    async getMyUnimed() {
      let usuario = new Usuario(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseUsuario = await usuario.getUnimed()
        this.codigoMinhaUnimed = responseUsuario.data.codigo
      } catch (err) {
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    verifyTextoPendencia() {
      const isAdmin = this.role === 'admin_brasil'

      this.tituloPendencia = isAdmin ? 'Anexo.' : 'Há uma pendência.'
      this.textoPendencia = isAdmin
        ? 'A atualização requer documento comprobatório. Deseja anexar agora?'
        : 'A sua atualização será analisada pela Unimed do Brasil. Deseja anexar o documento comprobatório agora?'
    },
    async salvarVersao(bool = false) {
      if (
        (this.currentTab === 'dados' && (await this.$refs.generic.$refs.dados.validarDados())) ||
        this.currentTab !== 'dados'
      ) {
        this.loadingCard = true
        this.showModalVersao = false

        await this.$nextTick()

        document.documentElement.style.overflow = 'hidden'
        this.showPendencia = false

        const unimed = new Unimed(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
        this.showModalVersao = false

        this.verifyTextoPendencia()

        await unimed
          .putFinishEdit(bool)
          .then((res) => {
            res = res.data

            this.gerouPendencia = res.gerouPendencia
            this.showPendencia = res.necessitaDocComprobatorio
            this.salvandoVersao = res.necessitaDocComprobatorio
            this.abaAnexo = ''

            if (!res.necessitaDocComprobatorio) this.showSuccessAtualizacao = true
          })
          .catch((err) => {
            this.errObj.status = err.response.status
            this.errObj.error = err.response.data.message
            this.showModalVersao = false
            this.showError = true
          })
          .finally(() => (this.loadingCard = false))
      }
    },
    async mostrarModalDeSucesso() {
      this.showCancelarVersao = false
      await this.goToHomeEditar()
    },
    async goToHomeEditar() {
      this.loadingCard = true
      let unimed = new Unimed(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      try {
        await unimed.putCancelEdit()
        this.showSucess = false
        this.loadingCard = false
        const objVoltar = {
          path: localStorage.getItem('paginaPassada') === 'consultarUnimed' ? '/consultarUnimed' : '/home'
        }
        this.$router.push(objVoltar)
      } catch (err) {
        this.loadingCard = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async canViewAnexos() {
      await this.getMyUnimed()
      if (
        (this.role === 'dirigente' || this.role === 'admin') &&
        this.codigoUnimedVisualizada === this.codigoMinhaUnimed
      ) {
      } else if (this.role === 'admin_brasil' || this.role === 'colaborador_brasil' || this.role === 'colaborador_dirigente') {
      } else {
        this.tabs[7].disabled = true
      }
    },
    async voltar() {
      this.$router.push({ path: '/home' })
    },
    async dados() {
      await this.$refs.generic.$refs.dados.validarMudanca()
    },
    async perfil() {
      await this.$refs.generic.$refs.perfil.validarMudanca()
    },
    async certificacoes() {
      await this.$refs.generic.$refs.certificacoes.validarMudanca()
    },
    closeModalAtualizacao() {
      this.showSuccessAtualizacao = false
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="sass" scoped>
$corBorda: #E8E8E8

.header-border
  border-bottom: 2px solid $corBorda

.vueBox
  display: grid !important
  flex: 1 !important
</style>


